import { render, staticRenderFns } from "./formatted-task-name.vue?vue&type=template&id=87d10b6e&scoped=true&"
import script from "./formatted-task-name.vue?vue&type=script&lang=js&"
export * from "./formatted-task-name.vue?vue&type=script&lang=js&"
import style0 from "./formatted-task-name.vue?vue&type=style&index=0&id=87d10b6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d10b6e",
  null
  
)

export default component.exports